import { BACKEND_URL } from "../constants/api.js";
import { toast } from "sonner";

export async function createCreditCheckoutSession(packId, token) {
  try {
    const res = await fetch(`${BACKEND_URL}api/credits/checkout`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ packId }),
    });

    const session = await res.json();

    if (!res.ok || !session.url) {
      toast.error(session.error || "Failed to start checkout. Please try again.");
      return;
    }

    window.location.href = session.url;
  } catch {
    toast.error("Failed to start checkout. Please try again.");
  }
}

export async function createSchoolCheckoutSession(schoolId, seatCount, token) {
  try {
    const res = await fetch(`${BACKEND_URL}api/schools/${schoolId}/checkout`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ seatCount }),
    });

    const session = await res.json();

    if (!res.ok || !session.url) {
      toast.error(session.error || "Failed to start checkout. Please try again.");
      return;
    }

    window.location.href = session.url;
  } catch {
    toast.error("Failed to start checkout. Please try again.");
  }
}
